import { lazy } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const PickDropConfig = lazy(() => import("../components/pickDropConfig"));

const pickDropConfigRoute = {
  icon: SettingsIcon,
  name: "Settings",
  path: "settings",
  link: "/settings",
  index: 25,
  children: [
    {
      path: "pickup-drop-config",
      element: <PickDropConfig/>,
      name: "Config for Pickup and Drop",
      link: "/settings/pickup-drop-config",
      icon: AdminPanelSettingsIcon,
      permission: "Config-Read",
      index: 3,
    },
  ],
};
export default pickDropConfigRoute;
